/**
 * The song generator's URL and its "free" name in each language, for the
 * one-link spots that point at it: the homepage footer (LandingV2's
 * MusicGeneratorFooterLink, and renderHomepageFooterLink in
 * server/_core/seo.ts for the crawler HTML).
 *
 * Oct 12 2026 (Search Console, US-heavy): /ai-music-generator sits at #13.4
 * for "ai music generator free" (about 11k searches a month in the US) and
 * #15.3 for "free ai music generator" (9.3k), under homepages of DR 28-41
 * sites. The homepage linked it once, in the crawler HTML only, as "AI music
 * generator"; /ai-music-video-generator and the free audio tools did not link
 * it at all. "Free" is true of the page: a song costs 5 credits and a free
 * account's credits refill to 10 a day (shared/aiMusicGeneratorHead.ts).
 *
 * Each name is the term the page's own copy uses in that language
 * (shared/aiMusicGeneratorTranslations.ts for the seven translated versions).
 * Renderers add the language prefix (/es/ai-music-generator).
 */

export const MUSIC_GENERATOR_PATH = "/ai-music-generator";

export const MUSIC_GENERATOR_LINK_LABELS = {
  en: "Free AI music generator",
  es: "Generador de música IA gratis",
  pt: "Gerador de música IA grátis",
  fr: "Générateur de musique IA gratuit",
  de: "Kostenloser KI-Musikgenerator",
  it: "Generatore di musica AI gratis",
  nl: "Gratis AI muziek generator",
  pl: "Darmowy generator muzyki AI",
  tr: "Ücretsiz yapay zeka müzik oluşturucu",
  id: "AI pembuat lagu gratis",
  vi: "Trình tạo nhạc AI miễn phí",
  ja: "無料のAI作曲ツール",
  ko: "무료 AI 음악 생성기",
  zh: "免费 AI 音乐生成器",
} as const;

export type MusicGeneratorLinkLang = keyof typeof MUSIC_GENERATOR_LINK_LABELS;

/** The song generator's name in `lang`; English for a language Solmi doesn't serve. */
export function musicGeneratorLinkLabel(lang: string): string {
  return (
    MUSIC_GENERATOR_LINK_LABELS[lang as MusicGeneratorLinkLang] ??
    MUSIC_GENERATOR_LINK_LABELS.en
  );
}
